import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Unregister any service workers — we don't need offline support (2026-04-26, #58)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => reg.unregister());
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
